export const spaData = {
    title: "СПА-Процедуры",
    link: "/spa", // Пока не используется напрямую в компоненте страницы
    submenu: [ // Массив SPA-процедур, которые будут карточками
        {
            title: "СПА - капсула",
            description: "Погрузитесь в мир гармонии и блаженства. СПА-капсула предлагает уникальное сочетание гидромассажа, хромотерапии, ароматерапии и пара для полного расслабления тела и ума. Ощутите, как стресс уходит, а энергия наполняет каждую клеточку.", // Примерное описание
            imageUrl: "Assets/Spa/1.webp" // Placeholder картинка (!!! Замени на реальный путь !!!)
        },
        {
            title: "Пилинги",
            description: "Откройте для себя секрет идеальной кожи с нашими профессиональными пилингами. Эта процедура бережно отшелушивает омертвевшие клетки, стимулируя регенерацию и выравнивая тон кожи. Результат – свежее, гладкое и сияющее лицо, готовое к новым свершениям!", // Примерное описание
            imageUrl: "Assets/Spa/2.jpg" // Placeholder картинка
        },
        {
            title: "Массажи",
            description: "Погрузитесь в мир глубокого расслабления и восстановления с нашими профессиональными массажами. От классического до расслабляющего, от точечного до спортивного – каждая техника направлена на снятие напряжения, улучшение кровообращения и восстановление жизненных сил. Почувствуйте, как мышцы расслабляются, а ум обретает покой, даря вам ощущение полного обновления и легкости.", // Примерное описание
            imageUrl: "Assets/Spa/Spa3.jpg" // Placeholder картинка
        },
        {
            title: "Фитотермотерапия",
            description: "Окунитесь в расслабляющее тепло, усиленное целебными свойствами трав. Эта уникальная процедура стимулирует детоксикацию, улучшает микроциркуляцию и способствует глубокому питанию кожи, даря вам ощущение обновления и легкости.", // Примерное описание
            imageUrl: "Assets/Spa/4.jpg" // Placeholder картинка
        },
        {
            title: "Аппаратная липосакция",
            description: "\n" +
                "Избавьтесь от локальных жировых отложений и целлюлита без хирургического вмешательства. Современные технологии аппаратной липосакции позволяют эффективно и безопасно смоделировать идеальный силуэт, улучшить контуры тела и вернуть коже гладкость и упругость.", // Примерное описание
            imageUrl: "Assets/Spa/5.jpg" // Placeholder картинка
        },
        {
            title: "Безинъекционная мезотерапия",
            description: "Мечтаете о глубоком питании и омоложении кожи без дискомфорта инъекций? Безинъекционная мезотерапия – это инновационная процедура, которая позволяет доставить активные сыворотки и коктейли в глубокие слои кожи без повреждения ее целостности. Результат – свежая, сияющая и упругая кожа, улучшение цвета лица и разглаживание мелких морщин.", // Примерное описание
            imageUrl: "Assets/Spa/6.jpg" // Placeholder картинка
        }
    ]
};